import httpClient from "../../../client/httpClient";
import { renameFileWithUUID } from "../../../utils/renameFileWithUUID";

export const fetchBanners = async (marketType) => {
    try {
        const res = await httpClient.get("v1/api/admin/banner/get-all", {
            params: marketType ? { marketType } : {}
        });
        const sortedBanners = res.data.sort((a, b) => a.id - b.id);
        return sortedBanners;
    } catch (error) {
        console.log("Error on fetching all banners", error);
        return Promise.reject(error);
    }
};

export const createBanner = async ({ name, image, marketType }) => {
    try {
        const formData = new FormData();
        formData.append("link", "");
        formData.append("banner", name);
        if (marketType) {
            formData.append("marketType", marketType);
        }

        const renamedImage = renameFileWithUUID(image.source);
        formData.append("bannerImage", renamedImage);

        const res = await httpClient.post("v1/api/admin/banner/save", formData);
        return res.data;
    } catch (error) {
        console.log("Error on creating banner", error);
        throw error;
    }
};

export const updateBanner = async ({ id, name, image, marketType }) => {
    try {
        const formData = new FormData();
        formData.append("link", "");
        formData.append("banner", name);
        if (marketType) {
            formData.append("marketType", marketType);
        }

        if (image.source) {
            const renamedImage = renameFileWithUUID(image.source);
            formData.append("bannerImage", renamedImage);
        }

        const res = await httpClient.put(`v1/api/admin/banner/update/${id}`, formData);

        return res.data;
    } catch (error) {
        console.log("Error on creating banner", error);
        throw error;
    }
};

export const deleteBanner = async (bannerId) => {
    try {
        await httpClient.delete(`v1/api/admin/banner/delete-by-id/${bannerId}`);
        return bannerId;
    } catch (error) {
        console.log("Error on creating banner", error);
        throw error;
    }
};
